import React from 'react';
import { Fieldset } from 'primereact/fieldset';

interface HowItWorksStepProps {
  legend: string;
  iconClass: string;
  description: string;
}

const HowItWorksStep: React.FC<HowItWorksStepProps> = ({ legend, iconClass, description }) => {
  return (
    <div className="col-12 md:col-4 mb-4">
      <Fieldset legend={legend} className="h-100 surface-card shadow-2 border-round">
        <i className={`${iconClass} text-4xl text-blue-500 mb-3`}></i>
        <p className="m-0 text-700">{description}</p>
      </Fieldset>
    </div>
  );
};

export default HowItWorksStep;